module.exports = __webpack_public_path__ + "static/media/fly0023.0425e325.webp";